import { Navigate, useLocation } from "react-router-dom"
import { connect } from "react-redux"

const PrivateRoute = ({ children, is_auth }) => {
    const location = useLocation()

    if (!is_auth) {
        return <Navigate to="/auth/login" state={{ from: location }} replace />
    }

    return children;
}

const mapStateToProps = (state) => ({
    is_auth: state.auth.authenticate,
})

export default connect(mapStateToProps)(PrivateRoute)